export { PROMO_FEATURE_FLAG, DUMMY_PROMO_CODE } from '@mc/promo-utils'

export const PROMO_I18N_NAMESPACE = '@mc/promos'

export const PROMO_BANNER_GIFT_ENTRY_SOURCE = 'promo_banner_gift'
